import { useQuery } from '@apollo/client';
import { useLogQueryError } from '../hooks/use-log-query-error';
import { REPORT_CARD_CHATBOT_ENABLED } from '../queries/chatbot.queries';

interface IUseChatbotAccessArgs {
  playerAssessmentId: string;
  token?: string;
}

// hook — the server decides; see "Chatbot access is decided by the server" in CLAUDE.md.
export const useChatbotAccess = (
  { playerAssessmentId, token }: IUseChatbotAccessArgs
): { hasChatbot: boolean; loading: boolean } => {
  const { data, loading, error } = useQuery(REPORT_CARD_CHATBOT_ENABLED, {
    variables: { playerAssessmentId, token },
    fetchPolicy: 'cache-and-network',
  });
  useLogQueryError(error, 'useChatbotAccess');

  // A cached answer stays shown during the background refetch, so an open widget isn't unmounted.
  return { hasChatbot: data?.reportCardChatbotEnabled === true, loading: loading && !data };
};
